import { render } from "./Number.vue?vue&type=template&id=1cb2dcce"
import script from "./Number.vue?vue&type=script&lang=js"
export * from "./Number.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/health-cert/infs-vue-example/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__